import { render, staticRenderFns } from "./client-codes-edit-tab.vue?vue&type=template&id=7531ad26&scoped=true"
import script from "./client-codes-edit-tab.vue?vue&type=script&lang=js"
export * from "./client-codes-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./client-codes-edit-tab.vue?vue&type=style&index=0&id=7531ad26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7531ad26",
  null
  
)

export default component.exports